import { SIZES } from '@fsd/shared/constants';

export type ChipSizes = 's' | 'm' | 'l';

export const CLASSES_BY_SIZE = {
  [SIZES.S]: 'px-2 h-6',
  [SIZES.M]: 'px-3 h-8',
  [SIZES.L]: 'px-4 h-10',
};
